export default __webpack_public_path__ + "static/media/profile.ecd6417f.gif";